<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'HautDePage'
});
</script>
<template>
  <ka-container
    code="haut-de-page"
    :data="page.$info.hautDePage">
    <!-- Fond -->
    <ka-container
      code="fond"
      :options="{ hidden: true }"
      :xs="{
        click: page.fondClickOnXs,
        hidden: false
      }" />
    <!-- Header -->
    <ka-container
      code="header"
      :options="{ hidden: true }"
      :xs="{
        click: page.headerClickOnXs,
        hidden: false
      }">
      <ka-icon
        code="icon"
        :options="{ hidden: true }"
        :xs="{
          click: page.iconClickOnXs,
          hidden: false
        }"
        value="i-fa-solid:icons"
        xs-value="i-fa-solid:times"
        inner />
      <ka-text
        code="entreprises"
        :options="{ hidden: true }"
        :xs="{
          click: page.entreprisesClickOnXs,
          $state: { selected: page.$data.toggleEntreprises === true && page.$data.toggleExpert === undefined && page.$data.toggleFormation === undefined },
          hidden: false
        }"
        :xs-selected="{ click: page.entreprisesClickOnXsWhenSelected }">
        <span v-html="t('hautDePage.header.entreprises.value', `Some text here`)" />
        <template #xs>
          <span v-html="t('hautDePage.header.entreprises.xs.value', `Entreprise`)" />
        </template>
      </ka-text>
      <ka-text
        code="expert"
        :options="{ hidden: true }"
        :xs="{
          click: page.expertClickOnXs,
          $state: { selected: page.$data.toggleExpert === true && page.$data.toggleEntreprises === undefined && page.$data.toggleFormation === undefined },
          hidden: false
        }"
        :xs-selected="{ click: page.expertClickOnXsWhenSelected }">
        <span v-html="t('hautDePage.header.expert.value', `Some text here`)" />
        <template #xs>
          <span v-html="t('hautDePage.header.expert.xs.value', `Expert`)" />
        </template>
      </ka-text>
      <!-- Toggle expert -->
      <ka-container
        code="toggle-expert"
        :options="{ hidden: true }"
        :xs="{ hidden: page.$data.toggleExpert === true ? false : null }">
        <!-- Container 1 -->
        <ka-container
          code="container-1"
          :options="{ hidden: true }"
          :xs="{ hidden: false }">
          <ka-text
            code="pourquoi-devenir-expert"
            :options="{
              href: { name: `hub-expert` },
              hidden: true
            }"
            :xs="{
              click: page.pourquoiDevenirExpertClickOnXs,
              hidden: false
            }">
            <span v-html="t('hautDePage.header.toggleExpert.container1.pourquoiDevenirExpert.value', `Some text here`)" />
            <template #xs>
              <span v-html="t('hautDePage.header.toggleExpert.container1.pourquoiDevenirExpert.xs.value', `Pourquoi devenir expert ?`)" />
            </template>
          </ka-text>
          <ka-icon
            code="icon-1"
            :options="{ hidden: true }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:check-circle" />
        </ka-container>
        <!-- Container 2 -->
        <ka-container
          code="container-2"
          :options="{ hidden: true }"
          :xs="{ hidden: false }">
          <ka-text
            code="comment-ca-marche"
            :options="{
              href: { name: `hub-expert-Fonctionnement` },
              hidden: true
            }"
            :xs="{
              click: page.commentCaMarcheClickOnXs,
              hidden: false
            }">
            <span v-html="t('hautDePage.header.toggleExpert.container2.commentCaMarche.value', `Some text here`)" />
            <template #xs>
              <span v-html="t('hautDePage.header.toggleExpert.container2.commentCaMarche.xs.value', `Comment ça marche ?`)" />
            </template>
          </ka-text>
          <ka-icon
            code="icon-2"
            :options="{ hidden: true }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:map" />
        </ka-container>
        <!-- Container 3 -->
        <ka-container
          code="container-3"
          :options="{ hidden: true }"
          :xs="{ hidden: false }">
          <ka-icon
            code="icon-3"
            :options="{ hidden: true }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:folder-open" />
          <ka-text
            code="text"
            :options="{
              href: { name: `hub-expert-Ressources` },
              hidden: true
            }"
            :xs="{
              click: page.textClickOnXs,
              hidden: false
            }">
            <span v-html="t('hautDePage.header.toggleExpert.container3.text.value', `Some text here`)" />
            <template #xs>
              <span v-html="t('hautDePage.header.toggleExpert.container3.text.xs.value', `Ressources`)" />
            </template>
          </ka-text>
        </ka-container>
      </ka-container>
      <ka-text
        code="contact"
        :options="{
          href: { name: `Infos` },
          hidden: true
        }"
        :xs="{
          click: page.contactClickOnXs,
          hidden: false
        }">
        <span v-html="t('hautDePage.header.contact.value', `Some text here`)" />
        <template #xs>
          <span v-html="t('hautDePage.header.contact.xs.value', `À propos`)" />
        </template>
      </ka-text>
      <!-- Container-btn-contact -->
      <ka-container
        code="container-btn-contact"
        :options="{ hidden: true }"
        :xs="{ hidden: false }">
        <HeaderBtnSonProfilOuConnexion instance-class="header-btn-son-profil-ou-connexion--p38" />
      </ka-container>
      <!-- Toggle entreprises -->
      <ka-container
        code="toggle-entreprises"
        :options="{ hidden: true }"
        :xs="{ hidden: page.$data.toggleEntreprises === true ? false : null }">
        <!-- Container 1 -->
        <ka-container
          code="container-4"
          :options="{ hidden: true }"
          :xs="{ hidden: false }">
          <ka-text
            code="text-1"
            :options="{
              href: { name: `hub-entreprise` },
              hidden: true
            }"
            :xs="{
              click: page.text1ClickOnXs,
              hidden: false
            }">
            <span v-html="t('hautDePage.header.toggleEntreprises.container4.text1.value', `Some text here`)" />
            <template #xs>
              <span v-html="t('hautDePage.header.toggleEntreprises.container4.text1.xs.value', `Pourquoi Matchers ? `)" />
            </template>
          </ka-text>
          <ka-icon
            code="icon-4"
            :options="{ hidden: true }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:check-circle" />
        </ka-container>
        <!-- Container 2 -->
        <ka-container
          code="container-5"
          :options="{ hidden: true }"
          :xs="{ hidden: false }">
          <ka-text
            code="text-3"
            :options="{
              href: { name: `hub-entreprise-Fonctionnement` },
              hidden: true
            }"
            :xs="{
              click: page.text3ClickOnXs,
              hidden: false
            }">
            <span v-html="t('hautDePage.header.toggleEntreprises.container5.text3.value', `Some text here`)" />
            <template #xs>
              <span v-html="t('hautDePage.header.toggleEntreprises.container5.text3.xs.value', `Comment ça marche ?`)" />
            </template>
          </ka-text>
          <ka-icon
            code="icon-5"
            :options="{ hidden: true }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:map" />
        </ka-container>
        <!-- Container 3 -->
        <ka-container
          code="container-6"
          :options="{ hidden: true }"
          :xs="{ hidden: false }">
          <ka-icon
            code="icon-6"
            :options="{ hidden: true }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:book" />
          <ka-text
            code="text-4"
            :options="{
              href: { name: `Blog` },
              hidden: true
            }"
            :xs="{
              click: page.text4ClickOnXs,
              hidden: false
            }">
            <span v-html="t('hautDePage.header.toggleEntreprises.container6.text4.value', `Some text here`)" />
            <template #xs>
              <span v-html="t('hautDePage.header.toggleEntreprises.container6.text4.xs.value', `Blog`)" />
            </template>
          </ka-text>
        </ka-container>
        <!-- Container 4 -->
        <ka-container
          code="container-7"
          :options="{ hidden: true }"
          :xs="{ hidden: false }">
          <ka-icon
            code="icon-7"
            :options="{ hidden: true }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:search" />
          <ka-text
            code="text-5"
            :options="{
              href: `/experts`,
              ariaLabel: `text`,
              hidden: true
            }"
            :xs="{
              click: page.text5ClickOnXs,
              hidden: false
            }">
            <span v-html="t('hautDePage.header.toggleEntreprises.container7.text5.value', `Some text here`)" />
            <template #xs>
              <span v-html="t('hautDePage.header.toggleEntreprises.container7.text5.xs.value', `Rechercher un expert `)" />
            </template>
          </ka-text>
        </ka-container>
      </ka-container>
      <ka-text
        code="formation"
        :options="{ hidden: true }"
        :xs="{
          click: page.formationClickOnXs,
          $state: { selected: page.$data.toggleExpert === false && page.$data.toggleEntreprises === undefined && page.$data.toggleFormation === true },
          hidden: false
        }"
        :xs-selected="{ click: page.formationClickOnXsWhenSelected }">
        <span v-html="t('hautDePage.header.formation.value', `Some text here`)" />
        <template #xs>
          <span v-html="t('hautDePage.header.formation.xs.value', `Formations`)" />
        </template>
      </ka-text>
      <!-- Container Contact -->
      <ka-container
        code="container-contact"
        :options="{ hidden: true }"
        :xs="{ hidden: false }">
        <ka-button
          code="cta"
          :options="{
            ripple: true,
            href: { name: `Contact` }
          }"
          :xs="{ click: page.ctaClickOnXs }">
          <span v-html="t('hautDePage.header.containerContact.cta.value', `S'inscrire`)" />
          <template #xs>
            <span v-html="t('hautDePage.header.containerContact.cta.xs.value', `Contact`)" />
          </template>
        </ka-button>
      </ka-container>
      <!-- Toggle formation -->
      <ka-container
        code="toggle-formation"
        :options="{ hidden: true }"
        :xs="{ hidden: page.$data.toggleFormation === true ? false : null }">
        <!-- Container 1 -->
        <ka-container
          code="container-8"
          :options="{ hidden: true }"
          :xs="{ hidden: false }">
          <ka-text
            code="text-6"
            :options="{
              href: { name: `Formations` },
              hidden: true
            }"
            :xs="{
              click: page.text6ClickOnXs,
              hidden: false
            }">
            <span v-html="t('hautDePage.header.toggleFormation.container8.text6.value', `Some text here`)" />
            <template #xs>
              <span v-html="t('hautDePage.header.toggleFormation.container8.text6.xs.value', `Nos formations`)" />
            </template>
          </ka-text>
          <ka-icon
            code="icon-8"
            :options="{ hidden: true }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:folder-open" />
        </ka-container>
        <!-- Container 3 -->
        <ka-container
          code="container-9"
          :options="{ hidden: true }"
          :xs="{ hidden: false }">
          <ka-text
            code="tarifs"
            :options="{
              href: { name: `Financement` },
              hidden: true
            }"
            :xs="{
              click: page.tarifsClickOnXs,
              hidden: false
            }">
            <span v-html="t('hautDePage.header.toggleFormation.container9.tarifs.value', `Some text here`)" />
            <template #xs>
              <span v-html="t('hautDePage.header.toggleFormation.container9.tarifs.xs.value', `Tarifs & Financements`)" />
            </template>
          </ka-text>
          <ka-icon
            code="icon-9"
            :options="{ hidden: true }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:coins" />
        </ka-container>
        <!-- Container 2 -->
        <ka-container
          code="container-10"
          :options="{ hidden: true }"
          :xs="{ hidden: false }">
          <ka-text
            code="text-7"
            :options="{
              href: { name: `Pedagogie` },
              hidden: true
            }"
            :xs="{
              click: page.text7ClickOnXs,
              hidden: false
            }">
            <span v-html="t('hautDePage.header.toggleFormation.container10.text7.value', `Some text here`)" />
            <template #xs>
              <span v-html="t('hautDePage.header.toggleFormation.container10.text7.xs.value', `Pédagogie Matchers`)" />
            </template>
          </ka-text>
          <ka-icon
            code="icon-10"
            :options="{ hidden: true }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:chart-line" />
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncPageStore } from 'kapix-components-vue3'
import { hautDePageMenu } from './store'
import HeaderBtnSonProfilOuConnexion from '~/components/HeaderBtnSonProfilOuConnexion/index.vue'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p38')
const page = hautDePageMenu()
const props = withDefaults(defineProps<{
  toggleEntreprises?: Nullable<boolean>
  toggleExpert?: Nullable<boolean>
  toggleFormation?: Nullable<boolean>
}>(), {
  toggleEntreprises: undefined,
  toggleExpert: undefined,
  toggleFormation: undefined
})

syncPageStore(page, {
  props,
  propsToWatch: {
    toggleEntreprises: true,
    toggleExpert: true,
    toggleFormation: true
  }
})
</script>
